import axios from 'axios';
import API_BASE_URL from '../config.js';

const getDetailPrice = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/detaills-price/`,
            data 
        );
        const resp= {
            "status":response.status,
            "data": response.data
        }
    
        return resp;
      } catch (error) {
        return error.response.data
      }
    

};

export default getDetailPrice;
